const TSE_API = 'https://gateway.farabixo.com/api/v2';

export { TSE_API };
